<div class="handler_content" *ngIf="data && data.files">

  <ng-container *ngFor="let ff of data.files; index as idx;">
    <file-link
      [file]="ff"
      [type]="type"
      [ctaLink]="ctaLink"
      [readOnly]="readfilesonly"
      [hideByline]="hideByline"
      (openFile)="openFileDialog($event, ff, idx)"
    ></file-link>
  </ng-container>
  <ng-content></ng-content>
  <div class="empty-text" *ngIf="showNoFilesMessage">{{ noFilesMessage }}</div>
  <div class="upload_panel text_link" *ngIf="showLink && !readfilesonly && (!fileLimit || data.files.length < fileLimit)">
    <label (click)="openFileDialog($event)">{{ "+ " + addText }}</label>
  </div>
</div>